import * as React from 'react';

import { cn } from '@/shared/utils/index';
import { Label } from './label';

// Types that need special empty-state handling (no native placeholder support)
const DATE_TIME_TYPES = ['date', 'time', 'datetime-local', 'month', 'week'];

interface InputProps extends React.ComponentProps<'input'> {
  label?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, value, defaultValue, ...props }, ref) => {
  // For date/time inputs, track empty state for placeholder-like styling
  const isDateTimeType = type && DATE_TIME_TYPES.includes(type);
  const isEmpty = isDateTimeType && !value && !defaultValue;
  const internalId = React.useId();

  return (
    <div className='w-full space-y-2'>
      {props.label && <Label htmlFor={props.id ?? internalId}>{props.label}</Label>}
      <input
        id={props.id ?? internalId}
        type={type}
        value={value}
        defaultValue={defaultValue}
        data-empty={isEmpty ? 'true' : undefined}
        className={cn(
          'flex h-9 w-full rounded-md border border-border bg-input/30 px-3 py-2 text-text ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          className
        )}
        ref={ref}
        {...props}
      />
    </div>
  );
});
Input.displayName = 'Input';

export { Input };
